import { Component } from 'preact'
import Portal from 'preact-portal'
import qs from 'qs'
import { IdeaStatus } from '../../../control-components/ideation-status/Types'
import InputGroup from '../../../control-components/ui-components/InputGroup'
import IdeationFiltersBox from './IdeationFiltersBox'

interface Props {
  ideationStatuses: IdeaStatus[]
  selectedIdeationStatus: null | string
}

interface State {
  selectedIdeationStatus: null | string
  selectedIdeationStatusBeforeFiltersApply: null | string
  setPortal: boolean
}

export class IdeaStatusFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      selectedIdeationStatus:
        props.selectedIdeationStatus === null ? null : props.selectedIdeationStatus,
      selectedIdeationStatusBeforeFiltersApply: null,
      setPortal: false
    }
    this.setQueryParams = this.setQueryParams.bind(this)
    this.setSelectedIdeationStatus = this.setSelectedIdeationStatus.bind(this)
    this.updatePortalSetting = this.updatePortalSetting.bind(this)
  }

  setQueryParams(newStatus: string | null) {
    const searchQuery = window.location.search
    const queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
    // @ts-expect-error
    delete queryParameters?.filters?.ideationStatus

    const newQuery =
      newStatus === null
        ? { filters: queryParameters?.filters || {} }
        // @ts-expect-error
        : { filters: { ...(queryParameters?.filters || {}), ideationStatus: [newStatus] } }

    const combinedQuery = { ...queryParameters, ...newQuery }
    // @ts-expect-error
    delete combinedQuery?.page

    window.history.pushState('', '', `?${qs.stringify(combinedQuery)}`)
  }

  setSelectedIdeationStatus(newStatus: string | null) {
    this.setState({ selectedIdeationStatus: newStatus })
    this.setQueryParams(newStatus)
  }

  updatePortalSetting(evt: CustomEvent) {
    this.setState({
      selectedIdeationStatusBeforeFiltersApply: this.state.selectedIdeationStatus,
      setPortal: evt.detail.display
    })
  }

  componentDidMount() {
    window.addEventListener('filter', this.updatePortalSetting as EventListener)
    window.addEventListener('resetFilters', () => this.setSelectedIdeationStatus(null))
    window.addEventListener('revertFilters', () =>
      this.setSelectedIdeationStatus(this.state.selectedIdeationStatusBeforeFiltersApply)
    )
    window.addEventListener('ideationStatusFilterRemoval', () =>
      this.setSelectedIdeationStatus(null)
    )
  }

  componentWillUnmount() {
    window.removeEventListener('filter', this.updatePortalSetting as EventListener)
    window.removeEventListener('resetFilters', () => this.setSelectedIdeationStatus(null))
    window.removeEventListener('revertFilters', () =>
      this.setSelectedIdeationStatus(this.state.selectedIdeationStatusBeforeFiltersApply)
    )
    window.removeEventListener('ideationStatusFilterRemoval', () =>
      this.setSelectedIdeationStatus(null)
    )
  }

  render({ ideationStatuses }: Props, { setPortal }: State) {
    return (
      <div>
        <IdeationFiltersBox
          className='box__content box__pad ideation-filters is-hidden-M'
          ideationStatuses={ideationStatuses}
          selectedName={this.state.selectedIdeationStatus}
          onSelect={(name) => {
            this.setSelectedIdeationStatus(name)
          }}
        />
        {Boolean(setPortal) && (
          <Portal into='.instant-search__results-wrapper-filters'>
            <IdeationFiltersBox
              className='box__content box__pad ideation-filters'
              ideationStatuses={ideationStatuses}
              selectedName={this.state.selectedIdeationStatus}
              onSelect={(name) => {
                this.setSelectedIdeationStatus(name)
              }}
            />
          </Portal>
        )}
      </div>
    )
  }
}

interface PropsForConfigurator {
  title: string
  onChange: (state: { title: string }) => void
}

interface StateForConfigurator {
  title: string
}

export class IdeaStatusFilterWithHelp extends Component<PropsForConfigurator, StateForConfigurator> {
  constructor(props: PropsForConfigurator) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle(newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange(this.state))
  }

  render() {
    return (
      <div className=''>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: { target: HTMLInputElement }) => {
            this.onChangeTitle(e.target.value)
          }}
          value={this.state.title}
        />
      </div>
    )
  }
}

export default IdeaStatusFilter
